import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Input,
  InputGroup,
  InputGroupAddon
} from 'reactstrap';

/**
 * Counter input stateless component
 *
 * @param {Object} * Props
 * @returns {function} Component
 */
const CounterInput = ({count, onClickIncrement, onClickDecrement}) => (
  <div className="counter-input">
    <InputGroup>
      <InputGroupAddon addontype="prepend">
        <Button onClick={onClickDecrement}>
          Decrement
        </Button>
      </InputGroupAddon>
      <Input value={count} />
      <InputGroupAddon addontype="append">
        <Button onClick={onClickIncrement}>
          Increment
        </Button>
      </InputGroupAddon>
    </InputGroup>
  </div>
);

CounterInput.propTypes = {
  count: PropTypes.number.isRequired,
  onClickDecrement: PropTypes.func.isRequired,
  onClickIncrement: PropTypes.func.isRequired
};

export default CounterInput;



// WEBPACK FOOTER //
// ./src/components/CounterInput/index.js